export const tableHead = (age = 0) => ([
  {
    propName: 'name',
    labelName: '单位/万元',
  },
  {
    // type: 'first',
    propName: 'total',
    labelName: '退休期',
  },
  {
    // type: 'first',
    propName: 'discounted',
    labelName: `折现至${age}岁`,
  },
])

export const supplyEnum = {
  age: '',
  insuranceAmount: '社保领取', // 社保养老金额
  rentAmount: '房租收入', // 房租可提供金额
  annuityAmount: '年金领取', // 年金可提供金额
  otherAmount: '其他收入' // 其他收入可提供金额
}
